export default class Allocator {
  a: any;
  CurrentIndex: number | undefined;
  Start: string = "0";
  maxInclusive: string | undefined;
  Name: string = "";
  Id: string = "";
  doIncrementIndex: boolean = false;

  constructor(a: any) {
    this.a = a;
    this.CurrentIndex = a.CurrentIndex;
    this.Start = a.Start;
    this.maxInclusive = a.maxInclusive;
    this.Name = a.Name;
    this.Id = a.Id;
  }

  static allocators: Allocator[] = [];

  static getAllocator(AllocatorRefId: string): any {
    return Allocator.allocators.find((allocator: any) => allocator.Id == AllocatorRefId);
  }

  static updateAllocatorIndexes(repeatId: string): void {
    console.log("Repeat updateAllocatorIndexes", repeatId);
    Allocator.allocators.forEach((allocator) => {
      if (allocator.doIncrementIndex) {
        allocator.doIncrementIndex = false;
        allocator.CurrentIndex = (allocator.CurrentIndex || 0) + 1;
      }
    });
  }

  getCurrentIndex(): number {
    this.doIncrementIndex = true;
    return this.CurrentIndex || 0;
  }

  static resetAllocators() {
    Allocator.allocators.forEach((allocator) => {
      allocator.CurrentIndex = allocator.a.CurrentIndex;
    });
  }
}
